import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { ROUTES } from "utils/constants";

import Button from "components/Button";
import Container from "components/Container";
import Content from "components/Content";

import Logo from "../Logo";
import Signature from "../Signature";
import Stamp from "../Stamp";

import useFindings from "./useFindings";

export default function Findings() {
  const { t } = useTranslation();

  const navigate = useNavigate();

  const { companySettings } = useFindings();

  const { data: { templateStampPath = null, templateSignaturePath = null, companyLogoPath = null } = {}, isLoading } =
    companySettings;

  return (
    <Content isLoading={isLoading}>
      <Container className="flex flex-col gap-8 !pb-20">
        <div className="flex flex-col gap-3.5">
          <div>{t("profile.findings.sampleFindings")}</div>

          <Button
            type="button"
            className="w-full"
            onClick={() => navigate(ROUTES.PROFILE_TEMPLATES)}
            variant="secondary"
          >
            {t("profile.findings.changeSample")}
          </Button>
        </div>

        <div className="flex flex-col gap-3.5">
          <div>{t("profile.findings.reportTemplates")}</div>

          <Button
            type="button"
            className="w-full"
            onClick={() => navigate(ROUTES.PROFILE_REPORT_TEMPLATES)}
            variant="secondary"
          >
            {t("profile.findings.manageReportTemplates")}
          </Button>
        </div>

        <div className="flex flex-col gap-3.5">
          <div>{t("profile.findings.reportProcessing")}</div>

          <Button
            type="button"
            className="w-full"
            onClick={() => navigate(ROUTES.PROFILE_CATEGORIES)}
            variant="secondary"
          >
            {t("profile.findings.manageReportProcessing")}
          </Button>
        </div>
        <Signature templateSignaturePath={templateSignaturePath} />
        <Stamp templateStampPath={templateStampPath} />
        <Logo templateLogoPath={companyLogoPath} />
      </Container>
    </Content>
  );
}
